/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxMb: NonNullable<unknown> }} Error_Report_Image_Too_LargeInputs */

const es_co2_error_report_image_too_large = /** @type {(inputs: Error_Report_Image_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La imagen supera el tamaño máximo de ${i?.maxMb} MB.`)
};

/**

* @param {Error_Report_Image_Too_LargeInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_report_image_too_large = /** @type {((inputs: Error_Report_Image_Too_LargeInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_Image_Too_LargeInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_report_image_too_large(inputs)
});